import useAnalysisHooks from '@/hooks/analysis.hooks';
import {
  computed, onMounted, Ref, ref, watch,
} from 'vue';
import {
  RouteLocationNormalizedLoaded, Router, useRoute, useRouter,
} from 'vue-router';
import { CaseAnalysis } from './caseAnalysis';
import { JobView } from './jobView';

export default class EventDispatcher {
  analysisHooks = useAnalysisHooks();

  activeFrame = ref(0);

  route!: RouteLocationNormalizedLoaded;

  router!: Router

  frames = ref([
    {
      name: '案例分析',
    },
    {
      name: '作业查看',
    },
  ]);

  activeFrameName: Ref<string>;

  jobView: JobView;

  caseAnalysis: CaseAnalysis;

  handleFrameClick(index: number) {
    this.activeFrame.value = index;
  }

  handleAddClick() {
    this.analysisHooks.currentTeacherAssignmentStep.set('0');
    this.router.push({
      path: '/Teacher/addJob',
      query: {
        ...this.route.query,
        redirect: this.route.fullPath,
      },
    });
  }

  // 从 url 初始化页面参数
  initPage() {
    try {
      const activeFrame = parseInt(this.route.query.activeFrame as unknown as string, 10);
      if ([0, 1].includes(activeFrame)) {
        this.activeFrame.value = activeFrame as unknown as number;
      }
    } catch (e) {
      this.activeFrame.value = 0;
    }
  }

  constructor(caseAnalysis: CaseAnalysis, jobView: JobView) {
    this.caseAnalysis = caseAnalysis;
    this.jobView = jobView;
    this.route = useRoute();
    this.router = useRouter();
    this.activeFrameName = computed(() => this.frames.value[this.activeFrame.value].name);

    this.initPage();
    onMounted(() => {
      watch(() => this.activeFrame.value, (index: number) => {
        if (index === 0) {
          this.caseAnalysis.data.pagination.pageNo = 1;
          this.caseAnalysis.queryCaseAnalysis();
        } else {
          this.jobView.data.pagination.pageNo = 1;
          this.jobView.queryJobView();
        }
        this.router.push({
          path: this.route.path,
          query: { ...this.route.query, ...{ activeFrame: this.activeFrame.value, pageNo: 1 } },
        });
      });
    });
  }
}
